import clsx from 'clsx';
import { ReactNode } from 'react';
import styles from './styles.module.scss';

type IProps = {
  children: ReactNode;
  style?: 'centered' | 'space-between' | 'right';
  marginTop?: boolean;
  className?: string;
};

function ActionRow({ children, style, marginTop = true, className }: IProps) {
  return (
    <div
      className={clsx(
        styles.root,
        marginTop && styles.marginTop,
        !!style && styles[style],
        className
      )}
    >
      {children}
    </div>
  );
}

export default ActionRow;
